const translations = {
    apiError: 'Something went wrong. Please try again.',
    organization: 'Organization'
};

export default translations;
